import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { SovosSnackbar } from 's1-ui';
import { dismissMessage } from 'data/messages/messages.actions';
import CCPFooter from 'commonComponents/CCPFooter/CCPFooter';
import SetupRoutes from './SetupRoutes';
import AppRoutes from './AppRoutes';

const styles = {
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
  }
};

class BaseRoutes extends React.Component {
  static propTypes = {
    messages: PropTypes.array,
    dismissMessage: PropTypes.func.isRequired
  }

  static defaultProps = {
    messages: []
  };

  closeMessageBar = () => {
    this.props.dismissMessage();
  }

  render() {
    const { messages } = this.props;
    return (
      <div style={ styles.flexColumn }>
        <Switch>
          <Route
            path="/setup"
            component={ SetupRoutes }
          />
          <Route
            route="/"
            component={ AppRoutes }
          />
        </Switch>
        <CCPFooter />
        { messages && messages.length !== 0 && (
          <SovosSnackbar
            open
            message={ messages[0].text }
            variant={ messages[0].variant }
            onClose={ this.closeMessageBar }
            onAction={ this.closeMessageBar }
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { messages: state.messages };
}

const actions = { dismissMessage };

export default withRouter(connect(mapStateToProps, actions)(BaseRoutes));
